import React from "react";
import { Reveal } from "@/components/Reveal";
import { resolveImg } from "@/lib/api";

const INK = "#3d3527";

// italicise the quoted portion of a line (from the opening curly quote onward)
function renderLine(line = "") {
  const i = line.indexOf("\u201c");
  if (i === -1) return line;
  return (
    <>
      {line.slice(0, i)}
      <em className="italic font-normal" style={{ color: "#f2ead9", textShadow: "0 2px 14px rgba(61,53,39,0.35)" }}>{line.slice(i)}</em>
    </>
  );
}

export default function Manifesto({ data }) {
  const lines = [data?.line1, data?.line2, data?.line3].filter(Boolean);
  const image = resolveImg(data?.image || "/dna-banner.png");

  return (
    <section data-testid="manifesto-section" className="relative overflow-hidden">
      {/* full-width single background image (wall + nook) */}
      <img
        src={image}
        alt="Nat Habitat interior"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ objectPosition: "right center" }}
      />
      {/* warm gradient to keep the text side legible and unified */}
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(90deg, rgba(168,154,132,0.82) 0%, rgba(168,154,132,0.6) 34%, rgba(168,154,132,0.15) 52%, rgba(168,154,132,0) 66%)" }}
      />

      <div className="relative mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="md:w-[58%] md:pr-10 py-24 md:py-40 lg:py-48" style={{ color: INK }}>
          <Reveal>
            <div className="flex items-center gap-5 mb-10 md:mb-14">
              <span className="text-[11px] uppercase tracking-[0.32em]" style={{ color: "#8a6f45" }}>{data?.label}</span>
              <span className="h-px flex-1 max-w-[120px]" style={{ background: "rgba(138,111,69,0.5)" }} />
            </div>
          </Reveal>

          <h2 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl lg:text-[4.2rem] leading-[1.14] tracking-tight">
            {lines.map((l, i) => (
              <Reveal key={i} delay={i * 0.12}>
                <span className="block">{renderLine(l)}</span>
              </Reveal>
            ))}
          </h2>

          <Reveal delay={0.4}>
            <p className="mt-10 md:mt-14 text-[11px] uppercase tracking-[0.3em]" style={{ color: "rgba(61,53,39,0.6)" }}>
              {data?.subtitle}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
